<template>
  <div
    id="seckill-promotion"
    v-tangram-expose="
      Object.assign({}, module.data.rows[0].ssuList[0].tickerInfo, {
        extraTrack: module.data.rows[0].ssuList[0].extraTrack
      })
    "
    class="seckill promotion"
    :style="module.containerStyle"
  >
    <count-down
      :module="module"
      :module-id="module.id"
      :event="module.events.countDown"
      :on-go-spike="goSpike"
      :add-listener="addListener"
      :remove-listener="removeListener"
    />
    <div class="goods-area">
      <div class="goods-wrapper">
        <scroll-view class="scroll-wrapper">
          <div v-for="(item, index) in goods" :key="index">
            <seckill-good
              :module="module"
              :sku="item"
              :ssu="item.ssuList[0]"
              :on-go-spike="goSpike"
            />
          </div>
        </scroll-view>
      </div>
    </div>
  </div>
</template>
<script>
import CountDown from './components/CountDown'
import ScrollView from '@/common/widget/ScrollView/index.vue'
import SeckillGood from './components/Good'
import { cmsRedirect } from '@/common/cms/cms_redirect'
export default {
  name: 'Seckill',
  components: {
    CountDown,
    ScrollView,
    SeckillGood
  },
  props: {
    module: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    goods() {
      // 秒杀商品取前4个商品进行展示
      const goodsList = (this.module.data && this.module.data.rows) || []
      const formatGoodsList = goodsList.slice(0, 4)
      return formatGoodsList
    }
  },
  methods: {
    goSpike(ssu) {
      const { action } = this.module.data
      action.tickerInfo = {}
      action.tickerInfo.click = ssu.tickerInfo.goods
      cmsRedirect(action)
    }
  }
}
</script>
<style lang="scss" scoped>
.seckill {
  &.promotion {
    position: relative;
    transform: translate3d(0, 0, 0);

    overflow: hidden;

    backface-visibility: hidden;
    .goods-area {
      box-sizing: border-box;

      padding-bottom: 0.12rem;
      @include flex(row, flex-start, center, nowrap);

      .goods-wrapper {
        flex: auto;
        overflow-x: scroll;
        .scroll-wrapper {
          @include flex(row, space-between, flex-start, nowrap);
        }
      }

      .show-more-wrapper {
        width: 112px;

        margin-top: 4px;

        flex: none;
        align-self: center;
        @include flex(column, center, center, nowrap);

        .show-more-text {
          writing-mode: vertical-lr;

          font-size: 22px;
          letter-spacing: 8px;
          color: #999;
        }
      }
    }
  }
}
</style>
